

import ComponentLoader from '/root/project/node_modules/@uplight/marketplace-components/lib/ComponentLoader';
import SiteHeaderCheckout from '/root/project/node_modules/@uplight/marketplace-components/src/layout/SiteHeaderCheckout/SiteHeaderCheckout';
import CartFull from '/root/project/node_modules/@uplight/marketplace-components/src/cart/CartFull/containers/CartFull';
import CheckoutConfirmation from '/root/project/node_modules/@uplight/marketplace-components/src/checkout/CheckoutConfirmation/containers/CheckoutConfirmation';
import Shipping from '/root/project/node_modules/@uplight/marketplace-components/src/checkout/Shipping/containers/Shipping';
import Payment from '/root/project/node_modules/@uplight/marketplace-components/src/checkout/Payment/containers/Payment';
import Identity from '/root/project/node_modules/@uplight/marketplace-components/src/rebate/Identity/containers/Identity';
import Survey from '/root/project/node_modules/@uplight/marketplace-components/src/rebate/Survey/containers/Survey';
import ExpiredSession from '/root/project/node_modules/@uplight/marketplace-components/src/rebate/ExpiredSession/ExpiredSession';


const componentList = [
  SiteHeaderCheckout,
  CartFull,
  CheckoutConfirmation,
  Shipping,
  Payment,
  Identity,
  Survey,
  ExpiredSession,
];

new ComponentLoader(componentList).load();
